import { BrowserModule } from '@angular/platform-browser';
import { HighchartsChartModule } from 'highcharts-angular';
import { NgModule, OnInit } from '@angular/core';
import { FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { RouterModule, Router, NavigationEnd } from '@angular/router';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { LoginComponent } from './login/login.component';
import { SigninOidcComponent } from './signin-oidc/signin-oidc.component';
import { SiteLayoutComponent } from './site-layout/site-layout.component';


import { EgHomeComponent } from './dashboard/eg-home/eg-home.component';
import { NeditDashboardComponent } from './dashboard/nedit-dashboard/nedit-dashboard.component';


//Home Dashboard
import { HomeComponent } from './dashboard/home/home.component';
//Vendor index Dasboard
import { IndexComponent } from './vendor/index/index.component';
//Production Dasboard
import { OsaStaffPortalComponent } from './dashboard/osa-staff-portal/osa-staff-portal.component';
import { ApsStaffPortalComponent } from './dashboard/aps-staff-portal/aps-staff-portal.component';
import { PrdMgrComponent } from './dashboard/prd-mgr/prd-mgr.component';
import { PrdStaffComponent } from './dashboard/prd-staff/prd-staff.component';
import { PrdSupComponent } from './dashboard/prd-sup/prd-sup.component';
import { EmpGraphComponent } from './dashboard/emp-occupancy/emp-graph/emp-graph.component';
import { EmpGraphTransComponent } from './dashboard/emp-occupancy/emp-graph-trans/emp-graph-trans.component';
import { EmpOccupancyComponent } from './dashboard/emp-occupancy/emp-occupancy.component';

import { IssuesComponent } from './issues/issues.component';
import { IssueconfigComponent } from './issues/issueconfig/issueconfig.component';

import { UserMasterComponent } from './users/user-master/user-master.component';
import { UserProfileComponent } from './users/user-profile/user-profile.component';
import { RoleMasterComponent } from './users/role-master/role-master.component';

import { StatusComponent } from './general/status/status.component';

import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { PwdChangeComponent } from './users/pwd-change/pwd-change.component';
import { ExceptionReportComponent } from './exception-report/exception-report.component';
import { UploadComponent } from './upload/upload.component';
import { IngestionComponent } from './ingestion/ingestion.component';
import { ProjectPlanComponent } from './project-plan/project-plan.component';
import { JournalsComponent } from './journals/journals.component';
import { TransactionComponent } from './transaction/transaction.component';
import { WorkflowComponent } from './workflow/workflow.component';
import { ArticleinfoComponent } from './articleinfo/articleinfo.component';
import { QuickSearchComponent } from './quick-search/quick-search.component';
import { PublisherMasterComponent } from './Publisher/publisher-master/publisher-master.component';
import { VendorMasterComponent } from './vendor/vendor-master/vendor-master.component';
import { ConfigComponent } from './vendor/config/config.component';
import { ProofingConfigComponent } from './Proofing/proofing-config/proofing-config.component';
import { ArticleComponent } from './article/article.component';
import { ArticleMetaComponent } from './articlemeta/articlemeta.component';
import { ArticleMonitorComponent } from './articlemonitor/articlemonitor.component';
import { ArticlemonitorinfoComponent } from './articlemonitorinfo/articlemonitorinfo.component';
import { ArticleStatusReportComponent } from "./Reports/article-status-report/article-status-report.component";
import { ArticleStatusReceivedComponent } from "./Reports/article-status-received/article-status-received.component";
import { HomeIndexComponent } from './home/home.component';
import { MsalModule, MsalInterceptor } from '@azure/msal-angular';
import { AuthService } from './auth.service';
import { environment } from '../environments/environment';
import { NotificationComponent } from './notification/notification.component';
import { MailTemplateComponent } from './mail-template/mail-template.component';
import { AuthorEptComponent } from "./author-ept/author-ept.component";
import { FeedbackListComponent } from "./feedback-list/feedback-list.component";
import { BioRxivComponent } from './dashboard/biorxiv/biorxiv.component';

import { RegisterComponent } from "./Freelancer/register/register.component";
import { FreelancerDashboardComponent } from "./Freelancer/freelancer-dashboard/freelancer-dashboard.component";
import { FreelancerlistComponent } from "./Freelancer/freelancerlist/freelancerlist.component";
import { TestAssignmentComponent } from "./Freelancer/test-assignment/test-assignment.component";
import { TestAssessmentComponent } from "./Freelancer/test-assessment/test-assessment.component";
import { FreelancerOnboardingComponent } from "./Freelancer/freelancer-onboarding/freelancer-onboarding.component";

import { DefectManagementComponent } from './defect-management/defect-management.component';
import { GridColumnMasterComponent } from './configuration/grid-column-master/grid-column-master.component';
import { IssueListComponent } from './issues/issue-list/issue-list.component';

import { IssueElementsComponent } from './configuration/issue-elements/issue-elements.component';
import { ProofingMailBodyComponent } from './mail-template/proofing-mailbody/proofing-mailbody.component';
import { authoreptinstructionComponent } from './authorept-instruction/authorept-instruction.component';

import { ProofingTypesComponent } from './general/proofing-types/proofing-types.component';
import { ExtApiconfigComponent } from './general/ext-api-config/ext-api-config.component';

import { BusinessRuleTypeComponent } from './Business Rule/BusinessRuleType/business-rule-type/business-rule-type.component';
import { BusinessRulesComponent } from './Business Rule/Business-Rules/business-rules.component';

import { MenulistComponent } from './configuration/menulist/menulist.component';
import { ArticleTypeComponent } from './ArticleTypeAndProcess/article-type/article-type.component';
import { ArticleProcessComponent } from './ArticleTypeAndProcess/article-process/article-process.component';

import { DefectMgtDashboardComponent } from './defect-mgt-dashboard/defect-mgt-dashboard.component';
import { PieChartComponent } from './Defect-mgt-childcomponents/pie-chart/pie-chart.component';
import { TopDisplayPannelComponent } from './Defect-mgt-childcomponents/top-display-pannel/top-display-pannel.component';
import { MasterGridComponent } from './Defect-mgt-childcomponents/master-grid/master-grid.component';
import { ChildViewGridComponent } from './Defect-mgt-childcomponents/child-view-grid/child-view-grid.component';
import { DefectResponseComponent } from './Defect-mgt-childcomponents/defect-response/defect-response.component';
import { DefectNewComponent } from './Defect-mgt-childcomponents/defect-new/defect-new.component';
import { ManuflowDashboardComponent } from './manuflowprocess/manuflow-dashboard/manuflow-dashboard.component';
import { ConversionrulesComponent } from './manuflowprocess/conversionrules/conversionrules.component';
import { UtilityProcessComponent } from './utility-process/utility-process.component';
import { CC3Component } from './cc3/cc3.component';
import { CC3ConfigComponent } from './cc3/cc3-config/cc3-config.component';
import { ManuscriptComponent } from './manuflowprocess/manuscript/manuscript.component';
import { PRAServicesComponent } from './pra-services/pra-services.component';
import { PraConfigComponent } from './pra-services/pra-config/pra-config.component';
import { journalmappingComponent } from './pra-services/PRA-Journal-Config/PRA-Journal-Config.component';
import { NTManualAllocationComponent } from './nt-allocation/nt-manual-allocation/nt-manual-allocation.component';
import { NTUserInbox } from './nt-allocation/nt-user-inbox/nt-user-inbox.component';
import { BatchSetComponent } from './nt-allocation/batchset/batchset.component';
import { NTArtWithdrawnComponent } from './nt-allocation/nt-withdue-page/nt-withdue.component';
import { TTPDashboardComponent } from './dashboard/ttp-dashboard/ttp-dashboard.component';
import { InlineStylesCSPModule } from './inline-styles-csp/inline-styles-csp.module';

import { weightageuserwiseComponent } from './weightage-userwise/weightage-userwise.component';
import { weightagerolewiseComponent } from './weightage-rolewise/weightage-rolewise.component';
import { weightagesendapprovalComponent } from './weightage-sendapproval/weightage-sendapproval.component';
import { weightageapprovalComponent } from './weightage-approval/weightage-approval.component';
import { weightageUserReportComponent } from './weightage-userReport/weightage-userReport.component';

import { EmpmetricsdisplayComponent } from './Empmetrics-display/Empmetrics-display.component';
import { ConsecutivereportComponent } from './Consecutive-report/Consecutive-report.component';
import { PraReviewComponent } from './pra-services/pra-review/pra-review.component';
import { PraTatProcessComponent } from './pra-services/pra_tat_process/pra_tat_process.component';


//import * as rg4js from 'raygun4js';

///*Raygun Implement*/
//const VERSION_NUMBER = '1.0.0.0';
//rg4js('apiKey', "9EVLRYrJSTeSlRFOf5z4Ag");
//rg4js('setVersion', VERSION_NUMBER);
//rg4js('enablePulse', true);

//bootstrapApplication(AppComponent, {
//  providers: [{
//    provide: CSP_NONCE,
//    useValue: 'UEBoLQwYhLlyft89XwfbLe4HKEwMowkXkra1tIjvKTc'
//  }]
//});

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent, SigninOidcComponent, SiteLayoutComponent, EgHomeComponent, NeditDashboardComponent, HomeIndexComponent,
    NavMenuComponent, BioRxivComponent, EmpGraphComponent, EmpGraphTransComponent, EmpOccupancyComponent,
    HomeComponent, OsaStaffPortalComponent, ApsStaffPortalComponent, PrdMgrComponent, PrdStaffComponent, PrdSupComponent, IndexComponent,
    ArticleComponent, ArticleMetaComponent, ArticleMonitorComponent, ArticlemonitorinfoComponent,
    IssuesComponent, IssueconfigComponent, IssueListComponent,
    UserProfileComponent, PwdChangeComponent, UserMasterComponent,
    RoleMasterComponent, StatusComponent,
    CounterComponent, DefectManagementComponent,
    UserProfileComponent, RoleMasterComponent,
    VendorMasterComponent, ProofingConfigComponent, ConfigComponent,
    WorkflowComponent, TransactionComponent, JournalsComponent, PublisherMasterComponent, MailTemplateComponent,
    ExceptionReportComponent, ProjectPlanComponent, IngestionComponent, UploadComponent, ArticleinfoComponent,
    FetchDataComponent, MenulistComponent, ArticleTypeComponent, ArticleProcessComponent,
    QuickSearchComponent, ArticleStatusReportComponent, ArticleStatusReceivedComponent, NotificationComponent,
    AuthorEptComponent, FeedbackListComponent, GridColumnMasterComponent,
    RegisterComponent, FreelancerlistComponent, TestAssignmentComponent, TestAssessmentComponent,
    FreelancerOnboardingComponent, FreelancerDashboardComponent,
    IssueElementsComponent, ProofingMailBodyComponent, authoreptinstructionComponent,
    ProofingTypesComponent, ExtApiconfigComponent,
    BusinessRuleTypeComponent, BusinessRulesComponent,
    DefectMgtDashboardComponent, PieChartComponent, TopDisplayPannelComponent, MasterGridComponent, ChildViewGridComponent,
    DefectResponseComponent, DefectNewComponent,
    ManuflowDashboardComponent, ConversionrulesComponent,
    UtilityProcessComponent, CC3Component, CC3ConfigComponent,
    NTManualAllocationComponent, NTUserInbox, BatchSetComponent, NTArtWithdrawnComponent,
    ManuscriptComponent, PRAServicesComponent, PraConfigComponent, PraReviewComponent, journalmappingComponent,
    TTPDashboardComponent,
    weightagerolewiseComponent, weightageuserwiseComponent, weightagesendapprovalComponent,
    weightageapprovalComponent, weightageUserReportComponent,
    EmpmetricsdisplayComponent, ConsecutivereportComponent,
    PraTatProcessComponent

  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    InlineStylesCSPModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot([
      { path: '', component: LoginComponent },
      { path: 'login', component: LoginComponent },
      { path: 'signin-oidc', component: SigninOidcComponent },
      { path: 'sigin-oidc', component: SigninOidcComponent },
      { path: '', component: LoginComponent, pathMatch: 'full' },
      { path: 'pwdchange', component: PwdChangeComponent },
      { path: 'feedback-list', component: FeedbackListComponent },
      { path: 'register', component: RegisterComponent },
      { path: 'freelancer-index', component: FreelancerDashboardComponent },
      { path: 'freelancer-onboard', component: FreelancerOnboardingComponent },


      {
        path: '', component: SiteLayoutComponent,
        children: [
          { path: 'home', component: HomeComponent, pathMatch: 'full' },
          { path: 'home-index', component: HomeIndexComponent, pathMatch: 'full' },
          { path: 'eg-home', component: EgHomeComponent },
          { path: 'nedit', component: NeditDashboardComponent },
          { path: 'osa-staff-portal', component: OsaStaffPortalComponent },
          { path: 'aps-staff-portal', component: ApsStaffPortalComponent },
          { path: 'dashboard', component: BioRxivComponent },
          { path: 'vendor-index', component: IndexComponent },
          { path: 'prd-mgr', component: PrdMgrComponent },
          { path: 'production-dashboard', component: PrdStaffComponent },
          { path: 'prd-sup', component: PrdSupComponent },
          { path: 'employee-profiling', component: EmpOccupancyComponent },
          { path: 'articles', component: ArticleComponent },
          { path: 'articles-monitor', component: ArticleMonitorComponent },
          { path: 'issues', component: IssuesComponent },
          { path: 'issue-config', component: IssueconfigComponent },
          { path: 'issue-list', component: IssueListComponent },
          { path: 'user-master', component: UserMasterComponent },
          { path: 'user-profile', component: UserProfileComponent },
          { path: 'role-master', component: RoleMasterComponent },
          { path: 'publisher-master', component: PublisherMasterComponent },
          { path: 'vendor-master', component: VendorMasterComponent },
          { path: 'proofing-config', component: ProofingConfigComponent },
          { path: 'config', component: ConfigComponent },
          { path: 'workflow', component: WorkflowComponent },
          { path: 'transaction', component: TransactionComponent },
          { path: 'journals', component: JournalsComponent },
          { path: 'exception', component: ExceptionReportComponent },
          { path: 'project-planning', component: ProjectPlanComponent },
          { path: 'ingestion', component: IngestionComponent },
          { path: 'quick-search', component: QuickSearchComponent },
          { path: 'status', component: StatusComponent },
          { path: 'field-update', component: CounterComponent },
          { path: 'fetch-data', component: FetchDataComponent },
          { path: 'reports', component: ArticleStatusReportComponent },
          { path: 'article-status-details', component: ArticleStatusReportComponent },
          { path: 'article-status-received', component: ArticleStatusReceivedComponent },
          { path: 'notification', component: NotificationComponent },
          { path: 'mail-template', component: MailTemplateComponent },
          { path: 'author-ept', component: AuthorEptComponent },
          { path: 'editor-ept', component: AuthorEptComponent },
          { path: 'proofing-ept', component: AuthorEptComponent },
          { path: 'freelancer-list', component: FreelancerlistComponent },
          { path: 'freelancer-test', component: TestAssignmentComponent },
          { path: 'freelancer-assessment', component: TestAssessmentComponent },
          { path: 'defect-mgt', component: DefectManagementComponent },
          { path: 'grid-master', component: GridColumnMasterComponent },
          { path: 'issue-element', component: IssueElementsComponent },
          { path: 'ept-instruction', component: authoreptinstructionComponent },
          { path: 'proofing-mailbody', component: ProofingMailBodyComponent },
          { path: 'proofing-types', component: ProofingTypesComponent },
          { path: 'external-api-config', component: ExtApiconfigComponent },
          { path: 'business-ruleType', component: BusinessRuleTypeComponent },
          { path: 'business-rules', component: BusinessRulesComponent },
          { path: 'defect-dashboard', component: DefectMgtDashboardComponent },
          { path: 'defect-response', component: DefectResponseComponent },
          { path: 'new-defect', component: DefectNewComponent },
          { path: 'pie-chart', component: PieChartComponent },
          { path: 'top-pannel', component: TopDisplayPannelComponent },
          { path: 'journal-master', component: MasterGridComponent },
          { path: 'journal-Details', component: ChildViewGridComponent },
          { path: 'article-type', component: ArticleTypeComponent },
          { path: 'article-process', component: ArticleProcessComponent },
          { path: 'manuflow', component: ManuflowDashboardComponent },
          { path: 'conversion-rules', component: ConversionrulesComponent },
          { path: 'utility-config', component: UtilityProcessComponent },
          { path: 'nlogic', component: CC3Component },
          { path: 'cc3-centralized-system', component: CC3Component },
          { path: 'cc3-config', component: CC3ConfigComponent },
          { path: 'mes-dashboard', component: ManuscriptComponent },
          { path: 'nt-allocation', component: NTManualAllocationComponent },
          { path: 'nt-user-inbox', component: NTUserInbox },
          { path: 'nt-withdraw', component: NTArtWithdrawnComponent },
          { path: 'batch-upload', component: BatchSetComponent },
          { path: 'pra-services', component: PRAServicesComponent },
          { path: 'pra-config', component: PraConfigComponent },
          { path: 'pra-review', component: PraReviewComponent },
          { path: 'pra-journal-config', component: journalmappingComponent },
          { path: 'pra-tat', component: PraTatProcessComponent },
          { path: 'ttp-report', component: TTPDashboardComponent },
          { path: 'weightage-Rolewise', component: weightagerolewiseComponent },
          { path: 'weightage-Userwise', component: weightageuserwiseComponent },
          { path: 'weightage-SendApproval', component: weightagesendapprovalComponent },
          //{ path: 'weightage-levelMapping', component: weightagelevelMappingComponent },
          //{ path: 'weightage-levelMappingUserwise', component: weightagelevelMappingUserwiseComponent },
          { path: 'weightage-Approval', component: weightageapprovalComponent },
          { path: 'weightage-UserReport', component: weightageUserReportComponent }
        ]
      },
    ]),
    HighchartsChartModule,
    MsalModule.forRoot(
      {
        auth: {
          clientId: environment.clienId, // This is your client ID
          authority: environment.authority, // This is microsoft url with your tenant ID
          redirectUri: environment.redirectUrl,  // This is your redirect URI
          postLogoutRedirectUri: environment.postLogoutRedirectUri,
          navigateToLoginRequestUrl: true,
        },
        cache: {
          cacheLocation: 'localStorage',
          storeAuthStateInCookie: false, // Set to true for Internet Explorer 11
        },
      },
      {
        popUp: false,
        extraQueryParameters: {}
      }
    )
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: MsalInterceptor,
    multi: true
  },
    AuthService,
  {
    provide: 'nonce',
    useValue: 'UEBoLQwYhLlyft89XwfbLe4HKEwMowkXkra1tIjvKTc'
  }
  ],
  bootstrap: [AppComponent]
})
export class AppModule implements OnInit {
  constructor(private router: Router) {
  }
  ngOnInit() {
    //this.router.events.subscribe(event => {
    //  if (event instanceof NavigationEnd) {
    //    // Track navigation end
    //    rg4js('trackEvent', {
    //      type: 'pageView',
    //      path: event.url
    //    });
    //  }
    //});
  }
}
